import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getOrgTree } from '../../../api/user';
import AddModal from './add-modal.vue';
import { EventBus } from '@blade/common';
let default_1 = class default_1 extends Vue {
    data = [];
    defaultProps = {
        children: 'sub_orgs',
        label: 'org',
    };
    filterText = '';
    visible = false; // 控制部门操作弹框
    showRemove = false; // 控制部门删除按钮
    selectedNode = {};
    handleNodeClick(data) {
        EventBus.$emit('changeOrgId', data.org.id);
    }
    onEdit(node) {
        this.visible = true;
        this.showRemove = true;
        this.selectedNode = node;
        EventBus.$emit('getOrgName', node.data?.org.org_name);
    }
    onAdd(data) {
        if (data.level >= 4) {
            this.$message({
                message: this.$t('cannotBeAdd'),
                type: 'warning',
            });
            return;
        }
        this.visible = true;
        this.showRemove = false;
        this.selectedNode = data;
    }
    filterTextChange(val) {
        this.$refs.tree.filter(val);
    }
    // 关键字过滤
    filterNode(value, data) {
        if (!value)
            return true;
        return data.org.org_name.indexOf(value) !== -1;
    }
    getOrgTree() {
        this.data = [];
        getOrgTree().then((res) => {
            this.data.push(res);
        });
    }
    mounted() {
        this.getOrgTree();
        EventBus.$on('getOrgTree', () => {
            this.getOrgTree();
        });
    }
};
__decorate([
    Watch('filterText')
], default_1.prototype, "filterTextChange", null);
default_1 = __decorate([
    Component({
        name: 'AccountLeftTree',
        components: { AddModal },
        i18n: {
            messages: {
                en: {
                    inputHolder: 'Search ',
                    allDepartments: 'All Departments',
                    cannotBeAdd: 'Department level maximum: 4',
                },
                zh: {
                    inputHolder: '搜索',
                    allDepartments: '所有部门',
                    cannotBeAdd: '部门层级不能超过4级'
                },
            },
        },
    })
], default_1);
export default default_1;
